var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 41",
    style: {
      enableBackground: "new 0 0 40 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2195F2;}\n\t.st1{fill:#757575;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "6.6,4.8 8,7.4 10.7,8.9 8,10.4 6.6,13 5.2,10.4 2.4,8.9 5.2,7.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10.7,17.4 11.6,19 13.2,19.9 11.6,20.7 10.7,22.3 9.9,20.7 8.3,19.9 9.9,19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.7,3.4 21.4,4.7 22.8,5.5 21.4,6.2 20.7,7.6 20,6.2 18.6,5.5 20,4.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10,1.2 10.6,2.2 11.6,2.6 10.6,3.2 10,4 9.6,3.2 8.6,2.6 9.6,2.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,7.1c-1.4-1.4-3.1-2.6-4.8-3.5c1.4,2.6,2.2,5.7,2.2,9c0,10.8-8.7,19.4-19.4,19.4c-3.3,0-6.3-0.8-9-2.2 c0.9,1.8,2.1,3.4,3.5,4.8c3.6,3.5,8.5,5.7,13.8,5.7c10.8,0,19.4-8.7,19.4-19.4C38.7,15.6,36.6,10.6,33,7.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/Sleep.4401e5c74ee19912dc29861b64813f96.svg";
export { ForwardRef as ReactComponent };